const externalCarrierVisibilityRouter = {
  path: '/external-carrier-visibility',
  meta: {
    title: 'ExternalCarrierVisibility',
    icon: 'truck',
    adminOnly: true
  },
  children: [
    {
      path: 'vehicle-visibility',
      component: () => import('@/views/ExternalCarrierVisibility/VehicleVisibility/vehicle-visibility'),
      name: 'VehicleVisibility',
      meta: { title: 'VehicleVisibility' }
    },
    {
      path: 'manage-carrier',
      component: () => import('@/views/ExternalCarrierVisibility/ManageCarrier/manage-carrier'),
      name: 'ManageCarrier',
      meta: { title: 'ManageCarrier' }
    },
  ]
}

export default externalCarrierVisibilityRouter
